module.exports = __webpack_public_path__ + "static/woman_with_glasses-fe0b72951ac5187fdfa3692bd552284e.png";